// extracted by mini-css-extract-plugin
export default {"buttonText":"TodosActions_buttonText__3J08f","btn":"TodosActions_btn__HzImE"};